import React, { FC, useState, useEffect } from 'react'
import { stringify } from 'qs'
import { payMobx, bankCardMobx } from '@mobxStore'
import { payChannelMobx } from '@mobx/mall/payment'
import { IonContent, IonSpinner, IonToast } from '@ionic/react'
import { observer } from 'mobx-react'

let css = `
  body {
    margin: 0;
  }
  br {
    display: none;
  }
  form {
    text-align: center;
  }
  input, select {
    appearance: none;
    -webkit-appearance: none;
    display: inline-block;
    outline: 0;
    box-sizing: border-box;
    margin: 8px 0;
    border: 1px solid #F4F4F4;
    border-radius: 8px;
    height: 56px;
    padding: 0 15px;
    font-size: 14px;
    color: #161616;
    background-color: #F4F4F4;
  }
  input::placeholder {
    font-size: 14px;
  }
  #cccardlabel, #ccexpirylabel, #cccvvlabel {
    display: none;
  }
  label {
    display: inline-block;
    width: 16px;
    text-align: center;
    color: #7a7a7a;
  }
  #ccnumfield {
    width: calc(100% - 13px * 2);
  }
  #ccexpirymonth, #ccexpiryfieldmonth {
    width: calc(((100% - 16px) / 12 * 7 - 16px) / 7 * 3);
  }
  #ccexpiryyear, #ccexpiryfieldyear {
    width: calc(((100% - 16px) / 12 * 7 - 16px) / 7 * 4);
  }
  #ccexpirymonth {
    margin-right: 16px;
  }
  #cccvvfield {
    margin-left: 16px;
    width: calc((100% - 16px) / 12 * 5 - 13px * 2);
  }
  .error {
    color: red;
    border-color: red;
  }
`

// Chrome浏览器设备模拟模式，#ccexpiryfieldmonth 和 #ccexpiryfieldyear 两侧会加入额外的 margin
// 中间的 label 添加负 margin 来保持和真机相同的布局
if (navigator.maxTouchPoints === 1) {
  css += `
    label {
      margin: 0 -13px;
    }
    #ccexpirymonth {
      margin-right: -14px;
    }
  `
}

interface IProps {
  payRechargeFlag?: boolean;
  onAuthorize(card: TBankCardInfo): void;
}

const CardConnectTokenizer: FC<IProps> = ({ payRechargeFlag, onAuthorize }) => {
  const [loaded, setLoaded] = useState<boolean>(false)
  const [token, setToken] = useState<string>()
  const [expiry, setExpiry] = useState<string>()
  const [errorMessage, setErrorMessage] = useState<string>()
  const [authorizing, setAuthorizing] = useState<boolean>(false)

  const auth = async () => {
    setAuthorizing(true)
    try {
      let card: IMutBankCardInfo
      if (payRechargeFlag) {
        const { id, number } = await payMobx.authBankCard('CardConnectBankCard', token)
        card = {
          tokenType: 'multi',
          creditCardNo: id,
          creditCardNumber: number,
        }
      } else {
        card = await bankCardMobx.authorize('CardConnectBankCard', token)
      }
      onAuthorize(card)
    } catch (e) {
      console.error('error auth card', e)
      setErrorMessage(e.message)
    } finally {
      setAuthorizing(false)
    }
  }

  const tokenFromEvent = (event: MessageEvent) => {
    if (event.data) {
      try {
        const msg = JSON.parse(event.data)
        setToken(msg.message)
        setExpiry(msg.expiry)
      } catch (e) {
        // ignore
      }
    }
  }

  const onTokenizerLoaded = () => {
    setTimeout(() => {
      setLoaded(true)
    }, 300)
  }

  useEffect(() => {
    window.addEventListener('message', tokenFromEvent)
    return () => {
      window.removeEventListener('message', tokenFromEvent)
    }
  }, [])

  const { server, port } = payChannelMobx.channelAccount.CardConnectBankCard
  const params = {
    css,
    placeholder: 'Card number',
    placeholdermonth: 'MM',
    placeholderyear: 'YYYY',
    placeholdercvv: 'CVV',
    tokenizewheninactive: true,
    useexpiry: true,
    useexpiryfield: true,
    usecvv: true,
    // formatinput: true, // 不能开启这个选项，scan后CVV输入会有问题
  }
  const url = `https://${server}.cardconnect.com:${port}/itoke/ajax-tokenizer.html?${stringify(params)}`

  return (
    <>
      <IonToast
        position='top'
        color='danger'
        isOpen={!!errorMessage}
        onDidDismiss={() => setErrorMessage('')}
        message={errorMessage}
        duration={2000}
      />
      <IonContent className='mall-card-connect-tokenizer'>
        {!loaded && (
          <div className='loading-wrapper'>
            <IonSpinner />
            <div>{i18n.t('pay.jumpToProcessorPage')}</div>
          </div>
        )}
        {authorizing && (
          <div className='loading-wrapper'>
            <IonSpinner />
            <div>{i18n.t('pay.authorizingCard')}</div>
          </div>
        )}
        <iframe
          id='cardConnectTokenizer'
          name='cardConnectTokenizer'
          src={url}
          frameBorder='0'
          scrolling='no'
          onLoad={onTokenizerLoaded}
        />
        {!authorizing && (
          <>
            <div className='processor-power-by'>{i18n.t('pay.powerByProcessor')}</div>
            <button className='submit-button' disabled={!loaded || !token} onClick={auth}>
              {i18n.t('pay.confirmAddBankCard')}
            </button>
          </>
        )}
      </IonContent>
    </>
  )
}

export default observer(CardConnectTokenizer)
